<div *ngIf="isNewMemberConversionEnabled; else oldRegistration">
  <nmc-member-conversion></nmc-member-conversion>
</div>
<ng-template #oldRegistration>
  <app-membership-registration-new></app-membership-registration-new>
</ng-template>
